module.exports = __webpack_public_path__ + "static/media/spectrum.243b7c7c.svg";